/* eslint-disable react-hooks/exhaustive-deps */
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import React, { useState, useEffect, useCallback } from "react";
import { QueryRequestHelper } from "@_common/query-request-helper";
import {
  getAuditStatusTaskFilterList,
  getDataAuditStatusTaskList,
  getVendorFilterLegislation,
  downloadRetrificationReport,
  downloadMISReport,
} from "@services/audit.service";
import { formatText } from "@_common/format-text";
import ScrollableReactTable from "@components/ScrollableDatatable";
import ManageAuditNotfound from "@components/Page-Not-Found/manage-audit-not-found";
import { useParams } from "react-router-dom";
import { tableScoreColors } from "@_common/colors";
import { NavLink } from "react-router-dom";
import FooterWrapper from "@components/common/FooterWrapper";
import { useNavigate } from "react-router-dom";
import "./AuditStatus.scss";
import moment from "moment";
import { handleDownloadOnClick } from "@_common/downloadfile";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import Loader from "@components/common/Loader";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { toast } from "react-toastify";
import { cleanPayload } from "./Constant/Util";

const AuditTaskList: React.FunctionComponent = (props: any) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(100);
  const [page_no, setPage_no] = useState<number>(1);
  const [auidtCheckpointList, setAuidtCheckpointList] = useState<[]>([]);
  const [legislationsList, setLegislationsList] = useState<[]>([]);
  const [headerData, setHeaderData] = useState<any>(null);
  const [filterListData, setFilterListData] = useState<any>({});
  const [filterState, setFilterState] = useState({
    status: params.status || "",
    criticality: params.criticality || "",
    legislation_id: params.legislation_id || "",
  });

  const getSelectedValue = (options: any[], selectedId: string) => {
    if (!selectedId) return null;
    return options.find((option) => option.id === selectedId) || null;
  };
  const toFilterOptions = (arr: { value: string }[] = []) =>
    arr.map((item) => ({
      id: item.value,
      label: item.value.replace(/_/g, " "),
      value: item.value,
    }));

  const statusOptions = toFilterOptions(filterListData?.status || []);
  const criticalityOptions = toFilterOptions(filterListData?.criticality || []);

  const handleSelectFilter = (value: string, filterType: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    setFilterState((prev: any) => ({
      ...prev,
      [filterType]: value,
    }));
    if (value) {
      searchParams.set(filterType, value);
    } else {
      searchParams.delete(filterType);
    }
    searchParams.set("page_no", "1");
    navigate(`${window.location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  const handleRemoveFilter = (filterType: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    setFilterState((prev: any) => ({
      ...prev,
      [filterType]: "",
    }));
    searchParams.delete(filterType);
    searchParams.set("page_no", "1");
    navigate(`${window.location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  const handleClearAllFilters = () => {
    setFilterState({
      status: "",
      criticality: "",
      legislation_id: "",
    });
    const searchParams = new URLSearchParams(window.location.search);
    ["status", "criticality", "legislation_id"].forEach((key) =>
      searchParams.delete(key),
    );
    searchParams.set("page_no", "1");
    navigate(`${window.location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  const getLegislationsList = async (id: string, value: string) => {
    if (!resolvedVendorId || !resolvedLocationId) return;
    const dates = params.date ? new Date(params.date) : new Date();
    const payload = {
      legislation_id: id,
      search_text: value,
      page_no: 1,
      page_size: 100,
      vendor_id: resolvedVendorId,
      location_id: resolvedLocationId,
      group_id: params.group_id,
      month: params.date
        ? params.date.split("-")[1]
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : moment(dates).format("YYYY"),
      type: "AUDIT_CHECKPOINT",
    };
    const queryRequest = QueryRequestHelper(payload);
    const resp = await getVendorFilterLegislation(queryRequest);
    if (resp) {
      setLegislationsList(
        getValue(resp, "data", []).map((item: any) => ({
          id: item.id,
          label: item.legislation_name,
          value: item.legislation_name,
        })),
      );
    }
  };

  const getFilterList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    let payload: any = {
      location_id: id || params.location_id,
      vendor_id: params.vendor_id,
      group_id: params.group_id,
      region_id: params.region_id,
      month: params.date
        ? params.date.split("-")[1]
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : moment(dates).format("YYYY"),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getAuditStatusTaskFilterList(queryRequest);
      if (resp.statusCode === 200) {
        setFilterListData(resp.data);
      }
    } catch (error) {
      throw error;
    }
  };
  const resolvedVendorId = headerData?.vendor_id || params.vendor_id;
  const resolvedLocationId = headerData?.location_id || params.location_id;
  const resolvedAuditStatus = headerData?.audit_status || params.audit_status;

  useEffect(() => {
    if (params?.rowData) {
      try {
        const decodedData = JSON.parse(decodeURIComponent(params.rowData));
        setHeaderData(decodedData);
      } catch (error) {
        console.error("Error parsing row data:", error);
      }
    }
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [params.page_no, params.limit]);

  useEffect(() => {
    if (!props.permissionAPITriggered) return;
    if (!resolvedVendorId || !resolvedLocationId) return;

    if (params.legislation_id) {
      getLegislationsList(params.legislation_id, "");
    } else if (params.search_text) {
      getLegislationsList("", params.search_text);
    } else {
      getLegislationsList("", "");
    }

    getFilterList();
  }, [props.permissionAPITriggered, resolvedVendorId, resolvedLocationId]);

  useEffect(() => {
    if (!props.permissionAPITriggered) return;
    const isRectification = params.view_type === "RECTIFICATION_REPORT";
    if (isRectification) {
      // For rectification drill-down, audit_status is not passed in the URL.
      // We only need location_id (from route param or URL) to fetch the list.
      if (!id && !params.location_id) return;
      getData();
    } else {
      if (!resolvedAuditStatus) return;
      getData();
    }
  }, [
    resolvedAuditStatus,
    id,
    page_no,
    limit,
    props.permissionAPITriggered,
    filterState.status,
    filterState.criticality,
    filterState.legislation_id,
  ]);

  const getData = async () => {
    const dates = params.date ? new Date(params.date) : new Date();
    const payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : page_no,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      location_id: id || params.location_id,
      vendor_id: params.vendor_id,
      audit_status: headerData?.audit_status || params.audit_status,
      status: filterState.status || params.status,
      criticality: filterState.criticality || params.criticality,
      legislation_id: filterState.legislation_id || params.legislation_id,
    };
    const queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      const resp = await getDataAuditStatusTaskList(queryRequest);
      if (resp) {
        setAuidtCheckpointList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            created_at: moment(getValue(item, `created_at`, "")).format(
              "DD MMM YYYY",
            ),
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            city_name: getValue(item, `city.name`, ""),
            audit_status: formatText(getValue(item, `audit_status`, "")),
            remark: getValue(item, `audit_abservation_comment.comments`, ""),
            title_legislation: getValue(
              item,
              `checkpoint.legislation.legislation_name`,
              "",
            ),
            detail_compliance: getValue(
              item,
              `checkpoint.compliance_activity`,
              "",
            ),
            type: getValue(item, `checkpoint.legislation_rule.rule_name`, ""),
            checkpoint_score:
              getValue(item, `checkpoint_score`, "") === 1 ? "100%" : "0%",
          })),
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleDownloadRetrificationReport = async () => {
    const dates = params.date ? new Date(params.date) : new Date();
    const userSpec = getValue(localStorage, "user", "{}");
    const userId = getValue(JSON.parse(userSpec), "id", "");

    const payload = cleanPayload({
      month: params.date
        ? params.date.split("-")[1]
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : moment(dates).format("YYYY"),
      report_type: "MIS_AUDIT_STATUS_REPORT",
      report_name: "Rectification Report",
      type: "AUDIT_STATUS",
      city_id: params.city_id,
      location_id: id || params.location_id,
      vendor_id: params.vendor_id,
      group_id: params.group_id,
      region_id: params.region_id,
      is_redirect: "true",
      user_id: userId,
    });

    setIsLoading(true);
    try {
      const resp = await downloadRetrificationReport(payload);
      if (resp) {
        toast.success(getValue(resp, "message", "Export triggered successfully"));
        navigate(`/self-compliance-logs/MIS_AUDIT_STATUS_REPORT`);
      }
    } catch (error) {
      console.error("Download failed:", error);
      toast.error("Failed to download report");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePagination = useCallback(
    (newPageNo: string) => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("page_no", newPageNo);

      navigate(`${window.location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    },
    [navigate],
  );

  const handleChangeLimit = useCallback(
    (newLimit: string) => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("limit", newLimit);
      searchParams.set("page_no", "1");

      navigate(`${window.location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    },
    [navigate],
  );

  const DocumentsCell = useCallback(
    ({ documents }: { documents: any[] }) => {
      if (!documents || documents.length === 0) {
        return <span>-</span>;
      }
      return (
        <div className="documents-list">
          {documents.map((doc, index) => (
            <React.Fragment key={index}>
              <div
                className="p-0 text-decoration-underline"
                style={{
                  color: "#007bff",
                  border: "none",
                  background: "none",
                  fontSize: "12px",
                  width: "160px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleDownloadOnClick(
                    doc.url || "",
                    `${doc.name || "document"}${doc.extension || ""}`,
                    doc.key || "",
                  );
                }}
                title={`Download ${doc.name}${doc.extension || ""}`}
              >
                {doc.name}
                {doc.extension}
                {index < documents.length - 1 && <span>, </span>}
              </div>
            </React.Fragment>
          ))}
        </div>
      );
    },
    [handleDownloadOnClick],
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No.",
        width: 70,
        Cell: ({ row }: any) => {
          const currentPage = params.page_no ? parseInt(params.page_no) : 1;
          const currentLimit = params.limit ? parseInt(params.limit) : limit;
          return (currentPage - 1) * currentLimit + row.index + 1;
        },
      },
      {
        Header: "Title",
        accessor: "title_legislation",
        width: 200,
      },
      {
        Header: "Type",
        accessor: "type",
        width: 200,
      },
      {
        Header: "Detail",
        accessor: "detail_compliance",
        width: 300,
      },
      {
        Header: "Status",
        accessor: "audit_status",
        width: 120,
        Cell: ({ row }: any) => {
          const value = getValue(row, `values.audit_status`, "").toLowerCase();
          let backgroundColor = "";
          let textColor = "#000";
          switch (value) {
            case "complied":
              backgroundColor = "#90EE90";
              textColor = "#000";
              break;
            case "pending audit":
              backgroundColor = "#FFD700";
              textColor = "#000";
              break;
            case "non complied":
              backgroundColor = "#FF6B6B";
              textColor = "#fff";
              break;
            default:
              backgroundColor = "#f0f0f0";
              textColor = "#000";
          }
          return (
            <div
              className="score-chip text-center fw-medium rounded px-2 py-1"
              style={{ backgroundColor, color: textColor }}
            >
              {value ? value.charAt(0).toUpperCase() + value.slice(1) : "-"}
            </div>
          );
        },
      },
      {
        Header: "Remarks",
        accessor: "remark",
        width: 250,
        Cell: ({ row }: any) => {
          return (
            <div className="d-flex flex-column gap-1">
              <div>{row.original.remark}</div>
              {","}
              <div>{row.original.recommendation}</div>
            </div>
          );
        },
      },
      {
        Header: "Files",
        width: 180,
        Cell: ({ row }: any) => {
          const documents = row.original.documents;
          return <DocumentsCell documents={documents} />;
        },
      },
      {
        Header: "Rebuttal/Rectification Files",
        width: 200,
        Cell: ({ row }: any) => {
          const cycles = row.original?.vendor_checkpoint_audit_cycles ?? [];
          if (!Array.isArray(cycles)) {
            return <span>-</span>;
          }
          const documents = cycles
            .filter((cycleObj: any) => cycleObj?.cycle > 1)
            .flatMap((cycleObj: any) => cycleObj?.documents ?? []);

          return <DocumentsCell documents={documents} />;
        },
      },
    ],
    [params.page_no, params.limit, limit, DocumentsCell],
  );

  return (
    <DashboardLayout
      permissions={getValue(props, "tabPermissionList", [])}
      subTabPermissionList={getValue(props, "subTabPermissionList", [])}
    >
      <>
        <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="header-parent-icon-holder">
              <NavLink
                to={
                  params.view_type === "RECTIFICATION_REPORT"
                    ? `/audit/mis-reports?view_type=RECTIFICATION_REPORT&date=${params.date}`
                    : `/audit/audit-status?date=${params.date}`
                }
              >
                <img
                  src="/images/back-link.svg"
                  className="img-fluid ml-5"
                  height={24}
                  width={24}
                  alt=""
                />
              </NavLink>
            </div>
            <div className="title-wrapper me-2">
              <h6 className="dashbaord-wrapper__header-parent-title">
                {params.view_type === "RECTIFICATION_REPORT"
                  ? "MIS Report"
                  : "Audit Status"}
              </h6>
              <h4 className="dashbaord-wrapper__header-title">
                {params.view_type === "RECTIFICATION_REPORT"
                  ? "Rectification-Report details"
                  : "Checkpoint List"}
              </h4>
            </div>
          </div>

          <div className="d-flex align-items-center">
            <RightMenuHeaders
              monthYear={true}
              isYear={true}
              value={params.date ? new Date(params.date) : new Date()}
              onChange={(newDate: Date) => {
                const formatted = moment(newDate).format("YYYY-MM-DD");
                const next = new URLSearchParams(window.location.search);
                next.set("date", formatted);
                navigate(`${window.location.pathname}?${next.toString()}`, { replace: true });
              }}
              smartFilter={false}
              lineSeperator
              downloadSelfComplianceReport={params.view_type === "RECTIFICATION_REPORT"}
              handleDownloadSelfComplianceReport={handleDownloadRetrificationReport}
              downloadLoading={isLoading}
              viewDownloadedSelfComplianceReports={true}
              handleNavigateLogs={() => {
                  if (params.view_type === "RECTIFICATION_REPORT") {
                    navigate("/self-compliance-logs/MIS_AUDIT_STATUS_REPORT");
                  } else {
                    navigate("/self-compliance-logs/Manage_Audit");
                  }
              }}
              isApplyButtonRequied={false}
            />
          </div>
        </div>

        {/* Audit Report Header */}
        {headerData && (
          <div className="audit-header mb-0 p-4 text-white">
            <h5 className="fw-bold mb-2">
              Audit Report for All Criticalities, for All CheckItems, for All
              Acts
            </h5>

            <div className="fs-6 mb-2">
              <strong>Site:</strong> {headerData.site_name} -{" "}
              <strong>Vendor:</strong> {headerData.vendor_name}
            </div>

            <div className="fs-14 lh-lg d-flex flex-wrap gap-4">
              <span>
                <strong>Conducted By:</strong> Audit Support-
                {headerData.vendor_name || "N/A"}
              </span>

              <span>
                <strong>Audit Month:</strong>{" "}
                {params.date ? moment(params.date).format("MMMM-YYYY") : "N/A"}
              </span>

              <span>
                <strong>Services:</strong> Security Services
              </span>

              <span>
                <strong>No of employees:</strong>{" "}
                {headerData.headcount || "N/A"}
              </span>

              <span>
                <strong>Critical Score:</strong>{" "}
                <span
                  className="score-badge"
                  style={{
                    backgroundColor: tableScoreColors(
                      headerData.critical_score
                        ? parseFloat(headerData.critical_score)
                        : 0,
                    ),
                  }}
                >
                  {headerData.critical_score || "0"}%
                </span>
              </span>

              <span>
                <strong>Full Score:</strong>{" "}
                <span
                  className="score-badge"
                  style={{
                    backgroundColor: tableScoreColors(
                      headerData.full_score
                        ? parseFloat(headerData.full_score)
                        : 0,
                    ),
                  }}
                >
                  {headerData.full_score || "0"}%
                </span>
              </span>
            </div>
          </div>
        )}

        <div className="filters-section p-3 bg-light rounded mb-3">
          <div className="d-flex align-items-center justify-content-between mb-2">
            {(filterState.status ||
              filterState.criticality ||
              filterState.legislation_id) && (
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={handleClearAllFilters}
              >
                Clear All Filters
              </button>
            )}
          </div>

          <div className="row">
            <div className="col-4">
              <label className="form-label small mb-1">
                Filter by CheckItem Status
              </label>
              <SearchableDropdownSelect
                placeholder="Select Status"
                options={statusOptions}
                handleChange={(val: any) =>
                  val ? null : handleRemoveFilter("status")
                }
                handleClick={(e: any) =>
                  handleSelectFilter(getValue(e, "id", ""), "status")
                }
                value={getSelectedValue(statusOptions, filterState.status)}
                label="label"
                id="id"
              />
            </div>

            <div className="col-4">
              <label className="form-label small mb-1">
                Filter by Criticality
              </label>
              <SearchableDropdownSelect
                placeholder="Select Criticality"
                options={criticalityOptions}
                handleChange={(val: any) =>
                  val ? null : handleRemoveFilter("criticality")
                }
                handleClick={(e: any) =>
                  handleSelectFilter(getValue(e, "id", ""), "criticality")
                }
                value={getSelectedValue(
                  criticalityOptions,
                  filterState.criticality,
                )}
                label="label"
                id="id"
              />
            </div>

            <div className="col-4">
              <label className="form-label small mb-1">Filter by Act</label>
              <SearchableDropdownSelect
                placeholder="Select Act"
                options={legislationsList}
                handleChange={(val: any) =>
                  val ? null : handleRemoveFilter("legislation_id")
                }
                handleClick={(e: any) =>
                  handleSelectFilter(getValue(e, "id", ""), "legislation_id")
                }
                value={getSelectedValue(
                  legislationsList,
                  filterState.legislation_id,
                )}
                label="label"
                id="id"
              />
            </div>
          </div>
        </div>

        <div className="main-page-layout-wrapper">
          <div>
            {isLoading ? (
              <Loader />
            ) : auidtCheckpointList && auidtCheckpointList.length > 0 ? (
              <ScrollableReactTable
                columns={columns}
                data={auidtCheckpointList}
                getTableState={() => {}}
                rowClick={() => {}}
                checkboxlogo
                check={false}
                selectedIDs={""}
                getTrProps={() => {}}
              />
            ) : (
              <>
                {Object.keys(params).length !== 0 ? (
                  <>
                    <ManageAuditNotfound />
                  </>
                ) : (
                  <>
                    <ManageAuditNotfound />
                  </>
                )}
              </>
            )}
          </div>
          <FooterWrapper
            list={auidtCheckpointList}
            totalCount={totalCount}
            limit={limit}
            page_no={page_no}
            handleChangePagination={handleChangePagination}
            handleChangeLimit={handleChangeLimit}
            hideCount
          />
        </div>
      </>
    </DashboardLayout>
  );
};

export default AuditTaskList;
